module.exports = __webpack_public_path__ + "img/zdlogo.86685e73.png";